import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { LocaleProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import Routers from './routers';
// import { I18nContext, unparam } from 'utils/common';
// // 国际化
// import i18nZh_cn from "utils/zh_cn";
// import i18nEn_us from "utils/en_us";

// //获取页面参数
// const queryString = unparam(location.search);
// // 国际化
// const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
// const i18n = lang === "en_us" ? i18nEn_us : i18nZh_cn;

function render(){
	ReactDOM.render(
		(<LocaleProvider locale={zhCN}>
			<Routers />
	    </LocaleProvider>), document.getElementById('root')
	);
}

if(module.hot){
	module.hot.accept("./routers", render);
}

render();
